import Button from "@mui/material/Button";
import React from "react";

export const SelectButton = ({
  handleClick,
  mobile,
  label,
  disabled = false,
}) => {
  return (
    <Button
      onClick={handleClick}
      variant="contained"
      disabled={disabled}
      sx={{
        backgroundColor: disabled ? "#CCCCCC" : "#00e09d",
        borderRadius: mobile ? "4px" : "10px",
        height: mobile ? "26px" : "40px",
        color: "white",
        textTransform: "none",
        padding: "2px",
        width: "80%",
        margin: "4px 0",
        "&:hover": {
          backgroundColor: disabled ? "#CCCCCC" : "#00865E",
          boxShadow: "none",
        },
        "&:active": {
          backgroundColor: disabled ? "#CCCCCC" : "#00865E",
          boxShadow: "none",
        },
        boxShadow: "none",
        fontFamily: "proxima-nova, sans-serif",
        fontSize: mobile ? 12 : 18,
      }}
    >
      {label}
    </Button>
  );
};
